import { Grid, useMediaQuery, useTheme } from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
import StatusCard from './StatusCard';
import { StatusCardListOrderBy } from 'components/StatusCardList';
import { PublicUserDto, UserSearchParams } from 'utils/wemble-api.generated';

const LazyStatusCard = ({
  user,
  orderOption,
  handleClick,
  searchParams,
}: {
  user: PublicUserDto;
  orderOption: StatusCardListOrderBy;
  handleClick: () => void;
  searchParams?: UserSearchParams;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const measuredHeight = useRef<number | null>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting && el.firstElementChild) {
          measuredHeight.current = el.firstElementChild.getBoundingClientRect().height;
        }
        setIsVisible(entry.isIntersecting)
      },
      { rootMargin: '3000px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <Grid item xs={12} sm={6} md={4} lg={3} ref={ref}>
      {isVisible ? (
        <StatusCard user={user} orderOption={orderOption} handleClick={handleClick} searchParams={searchParams} />
      ) : (
        <div style={{ height: measuredHeight.current ?? (isMobile ? 77 : 242), borderRadius: isMobile ? '40px 20px 20px 40px' : 20 }} />
      )}
    </Grid>
  );
};

export default LazyStatusCard;
